import React from 'react'
import { Banner, Button } from '@lightspeed/design-system-react'
import { T } from '@transifex/react'

interface Props {
  onRetry: () => void
}

export const FailedCashMovementsBanner: React.FC<Props> = ({ onRetry }) => {
  return (
    <Banner variant="negative">
      <T _str="There was a problem loading recent cash movements." />
      <Button
        data-track="failed-banner-try-again"
        link
        variant="supplementary"
        onClick={onRetry}
        className="vd-ml1"
      >
        <T _str="Try again." _context="Button" />
      </Button>
    </Banner>
  )
}
